module.exports = __webpack_public_path__ + "../resources/img/ic_app_guide.5261fdb0.svg";